import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Button,
  CardHeader,
} from "reactstrap";
import classnames from "classnames";
import BreadCrumb from "Components/Common/BreadCrumb";
import TemplateFirst from "Components/Templates/TemplateFirst";
import TemplateSecond from "Components/Templates/TemplateSecond";
import TemplateThird from "Components/Templates/TemplateThird";
import CustomButton from "Components/Custom/CustomButton";
// import Icon from "Components/Icons/Icon";
import TemplatePreviewModal from "Components/Quotes/ManageQuotes/TemplatePreviewModal";
import ManageInvoiceSummary from "Components/Invoices/ManageInvoices/ManageInvoiceSummary";
import ManageInvoiceItem from "Components/Invoices/ManageInvoices/ManageInvoiceItem";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "Components/Hooks/hooks";
import { getInvoiceById } from "slices/thunks";
import { addItemsToState } from "slices/items/reducer";
import Select from "react-select";
import { addDaysToToday } from "utils/formatDates";
import ShareModal from "Components/Modals/ShareModal";
import { ErrorHandler, SuccessToast } from "utils/toast";
import { useScreenTour } from "tour/useScreenTour";
import { tourElementsIds } from "tour/tourElementsIds";
import OverlayGuide from "Components/Common/TourGuide/OverlayGuide";
import { editInvoiceApi } from "helpers/ApiManager";
import FullScreenLoader from "Components/Common/FullScreenLoader";
import Loader from "Components/Common/Loader";
import { createSelector } from "reselect";
import { selectInvoicesState } from "slices/invoices/reducer";
import { useSelector } from "react-redux";

const ManageInvoices = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [customActiveTab, setcustomActiveTab] = useState<string>("1");
  const { state } = useLocation();
  const [isEdit, setIsEdit] = useState<boolean>(!!state?.id);
  const [showTemplatePreview, setShowTemplatePreview] = useState(false);
  const [isSummaryCompleted, setIsSummaryCompleted] = useState<boolean>(false);
  const { user } = useAppSelector((state) => state?.auth);
  const [selectedDate, setSelectedDate] = useState<{
    issueDate: string;
    dueDate: string;
  }>({ issueDate: "", dueDate: "" });
  const quoteDetails = useAppSelector((state) => state.quote.quoteDetails);
  const configData = useAppSelector((state) => state.config.configData);
  const addedItems = useAppSelector((state) => state?.item?.addItems);
  const invoiceSelector = createSelector(selectInvoicesState, (state) => ({
    invoiceDetails: state.invoiceDetails,
    isLoading: state.status.fetchById,
    error: state.errors.fetchById,
  }));
  const { invoiceDetails, isLoading, error } = useSelector(invoiceSelector);
  const [jobDescription, setJobDescription] = useState<string>("");
  const [quoteTitle, setQuoteTitle] = useState<string>("");
  // const [, setIsLoadingDownload] = useState<boolean>(false);
  // const [pdfUrl, setPdfUrl] = useState<string>(invoiceDetails?.url ?? "");
  const [selectedTemplateLoading, setSelectedTemplateLoading] =
    useState<boolean>(false);
  const [selectedTemplate, setSelectedTemplate] = useState<string>(
    invoiceDetails?.template ?? "classic",
  );
  const [isHidePhoneNumber, setIsHidePhoneNumber] = useState<boolean>(false);

  useEffect(() => {
    if (isEdit && invoiceDetails) {
      setIsHidePhoneNumber(!invoiceDetails?.is_company_phone_number_show);
    }
  }, [isEdit, invoiceDetails]);

  useEffect(() => {
    setSelectedTemplate(invoiceDetails?.template ?? "classic");
    // setPdfUrl(invoiceDetails?.url ?? "");
  }, [invoiceDetails]);

  useEffect(() => {
    setJobDescription(quoteDetails?.job_description || "");
    setQuoteTitle(quoteDetails?.title || "");
  }, [quoteDetails]);

  console.log("QuoteDetails in index", quoteDetails);

  const filterOptions = useMemo(
    () =>
      [
        configData?.document_setting?.categories
          ?.by_category_subcategory_item && {
          label: "All",
          value: "by-category-subcategory-item",
        },
        configData?.document_setting?.categories?.by_category && {
          label: "By Category",
          value: "by-category",
        },
        configData?.document_setting?.categories?.by_subcategory && {
          label: "By Subcategory",
          value: "by-subcategory",
        },
        configData?.document_setting?.categories?.by_item && {
          label: "By Items",
          value: "by-item",
        },
      ].filter((item): item is { label: string; value: string } =>
        Boolean(item),
      ),
    [
      configData?.document_setting?.categories?.by_category,
      configData?.document_setting?.categories?.by_category_subcategory_item,
      configData?.document_setting?.categories?.by_item,
      configData?.document_setting?.categories?.by_subcategory,
    ],
  );

  const [selectedFilter, setSelectedFilter] = useState<{
    label: string;
    value: string;
  } | null>(null);

  useEffect(() => {
    if (!filterOptions.length) return;

    const fromQuote = invoiceDetails?.categorised
      ? filterOptions.find(
          (option) => option.value === invoiceDetails.categorised,
        )
      : null;

    setSelectedFilter(fromQuote ?? filterOptions[3]);
  }, [filterOptions, invoiceDetails?.categorised]);

  const [showShareModal, setShowShareModal] = useState(false);

  const summaryTour = useScreenTour("invoiceSummary", {
    condition: customActiveTab === "1" && !isEdit,
  });

  const itemsTour = useScreenTour("invoiceItems", {
    condition: customActiveTab === "2" && !isEdit,
  });

  // const tourGuideSteps: Step[] = [
  //   {
  //     element: "#invoice-manager",
  //     title: "Testing Step 1",
  //     description: "Description for step 1",
  //     waitForElement: true,
  //   },
  // ];

  const toggleCustom = (tab: any) => {
    console.log("TOGGLE CUSTOM", tab, isSummaryCompleted, isEdit);
    // Check if tab is clickable based on completion status
    if (tab === "1") {
      // Summary tab is always accessible
      setcustomActiveTab(tab);
    } else if (tab === "2" && (isSummaryCompleted || isEdit)) {
      // Items tab is accessible only if summary is completed
      setcustomActiveTab(tab);
    }
  };

  const handleItemsSubmit = () => {
    // navigate("/invoices");
    navigate("/invoice-details", { state: { id: invoiceDetails?.id } });
  };

  const handleSummarySubmit = () => {
    setIsSummaryCompleted(true);
    // setIsEdit(true);
    setcustomActiveTab("2"); // Navigate to Items tab
  };

  useEffect(() => {
    if (state?.id) {
      dispatch(getInvoiceById(state.id));

      setIsEdit(true);
    }
  }, [dispatch, state]);

  useEffect(() => {
    if (invoiceDetails && invoiceDetails.items) {
      dispatch(addItemsToState(invoiceDetails.items));
    }
  }, [invoiceDetails, dispatch]);

  useEffect(() => {
    const formatUI = (dateVal: string | Date) => {
      const d = new Date(dateVal);
      const day = String(d.getDate()).padStart(2, "0");
      const month = d.toLocaleString("en-GB", { month: "short" }); // Apr, Jun, etc.
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    };

    if (isEdit && invoiceDetails) {
      const issueDate = invoiceDetails?.paid_date
        ? formatUI(invoiceDetails?.paid_date)
        : formatUI(new Date()); // fallback today

      const dueDate = invoiceDetails?.due_date
        ? formatUI(invoiceDetails.due_date)
        : formatUI(
            addDaysToToday(
              configData?.billing_preferences.quote_expiration || 0,
            ),
          );

      setSelectedDate({ issueDate, dueDate });
    } else {
      const today = new Date();
      const expiry = addDaysToToday(
        configData?.billing_preferences.quote_expiration || 0,
      );

      setSelectedDate({
        issueDate: formatUI(today),
        dueDate: formatUI(expiry),
      });
    }
  }, [
    isEdit,
    invoiceDetails,
    configData?.billing_preferences?.quote_expiration,
  ]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [customActiveTab]);

  // const openShareModal = () => setShowShareModal(true);
  const closeShareModal = () => setShowShareModal(false);
  const [templateLoading, setTemplateLoading] = useState(false);
  // const handleShare = async () => {
  //   try {
  //     openShareModal();
  //   } catch (error) {
  //     ErrorHandler(error);
  //   }
  // };

  // const handleDownload = useCallback(async () => {
  //   try {
  //     setIsLoadingDownload(true);
  //     console.log("Downloading Invoice PDF...", pdfUrl);

  //     const pdf = `${pdfUrl}?download=1&t=${Date.now()}`;

  //     const link = document.createElement("a");
  //     link.href = pdf;
  //     link.download = `${invoiceDetails?.invoice_number}.pdf`;
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   } catch (error) {
  //     ErrorHandler(error);
  //   } finally {
  //     setIsLoadingDownload(false);
  //   }
  // }, [pdfUrl, invoiceDetails?.invoice_number]);

  if (isLoading === "loading") {
    return (
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <Loader error={error} />
      </Container>
    );
  }

  return (
    <React.Fragment>
      <FullScreenLoader
        isLoading={selectedTemplateLoading}
        message="Loading template..."
      />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={isEdit ? "Edit Invoice" : "New Invoice"}
            pageTitle={"Invoices"}
          />
          <div className="d-flex align-items-center justify-content-between w-100 mb-4">
            {/* LEFT TITLE AREA */}
            <div className="flex-shrink-0">
              <p className="fs-3 fw-bold mb-1">
                {isEdit ? "Edit Invoice" : "New Invoice"}
              </p>
            </div>

            {/* RIGHT BUTTON
            {invoiceDetails && (
              <div className="gap-2  d-flex">
                <CustomButton
                  text="Download"
                  className="bg-primary br-7"
                  leftIcon={<Icon name="WhiteDownload" />}
                  onClick={handleDownload}
                  loading={isLoadingDownload}
                />
                <CustomButton
                  text="Share"
                  className="bg-blue br-7"
                  leftIcon={<Icon name="Share" />}
                  onClick={handleShare}
                />
              </div>
            )} */}
          </div>

          <Row>
            <Col
              lg={6}
              xl={7}
              xxl={8}
              id={tourElementsIds.invoiceItemSummaryTour}
            >
              <Card className="br-10">
                <CardBody>
                  <Row className="row align-items-end border-bottom ">
                    <Col className="">
                      <div id="mail-filter-navlist">
                        <Nav
                          className="nav nav-tabs nav-tabs-custom nav-primary gap-1 text-center border-bottom-0"
                          role="tablist"
                        >
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: customActiveTab === "1",
                              })}
                              onClick={() => {
                                toggleCustom("1");
                              }}
                              style={{
                                fontSize: 16,
                                fontWeight: customActiveTab === "1" ? 500 : 400,
                                fontFamily: "Inter Tight",
                                color:
                                  customActiveTab === "1"
                                    ? "#082B60"
                                    : "#2D2D2D",
                                cursor: "pointer",
                              }}
                            >
                              Summary
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: customActiveTab === "2",
                                disabled: !isEdit && !isSummaryCompleted,
                              })}
                              onClick={() => {
                                toggleCustom("2");
                              }}
                              style={{
                                fontSize: 16,
                                fontWeight: customActiveTab === "2" ? 500 : 400,
                                fontFamily: "Inter Tight",
                                color:
                                  !isSummaryCompleted && !isEdit
                                    ? "#B0B0B0"
                                    : customActiveTab === "2"
                                    ? "#082B60"
                                    : "#2D2D2D",
                                cursor:
                                  isSummaryCompleted || isEdit
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: isSummaryCompleted || isEdit ? 1 : 0.6,
                              }}
                            >
                              Items
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </div>
                    </Col>
                  </Row>

                  <TabContent activeTab={customActiveTab}>
                    <TabPane tabId="1">
                      <ManageInvoiceSummary
                        template={selectedTemplate}
                        categorised={selectedFilter?.value ?? ""}
                        isEdit={isSummaryCompleted || isEdit}
                        onSubmit={handleSummarySubmit}
                        invoiceData={
                          isSummaryCompleted || isEdit ? invoiceDetails : null
                        }
                        onDatesChange={(
                          quoteDate?: string,
                          expiryDate?: string,
                        ) => {
                          setSelectedDate((prev) => ({
                            issueDate: quoteDate ?? prev.issueDate,
                            dueDate: expiryDate ?? prev.dueDate,
                          }));
                        }}
                        quoteId={state?.quoteId}
                        reference_number={state?.reference_number}
                        isHidePhoneNumber={isHidePhoneNumber}
                        handleHidePhoneNumberToggle={() =>
                          setIsHidePhoneNumber((prev) => !prev)
                        }
                      />
                    </TabPane>
                    <TabPane tabId="2">
                      <ManageInvoiceItem onSubmit={handleItemsSubmit} />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
            <Col
              lg={6}
              xl={5}
              xxl={4}
              id={tourElementsIds.invoiceLivePreviewTour}
            >
              <Card className="br-10">
                <CardHeader className="br-tl-10 br-tr-10 border-bottom-0">
                  <div className="d-flex w-100 justify-content-between align-items-center p-1">
                    <Button className="btn bg-green-50 border-0 text-green d-flex gap-2 justify-content-center align-items-center px-2">
                      <span
                        className="d-inline-block bg-success rounded-circle mx-2 shadow-lg shadow-live"
                        style={{
                          width: "10px",
                          height: "10px",
                        }}
                      ></span>
                      Live Preview
                    </Button>
                    <div className="d-flex gap-2">
                      {customActiveTab === "2" && addedItems.length > 0 && (
                        <div>
                          <Select
                            name="option"
                            options={filterOptions}
                            value={selectedFilter}
                            onChange={async (option: any) => {
                              if (invoiceDetails?.id) {
                                console.log("option", option);

                                try {
                                  setSelectedTemplateLoading(true);
                                  const response = await editInvoiceApi({
                                    invoice_id: invoiceDetails?.id,
                                    categorised: option.value,
                                  });
                                  console.log(response);
                                  // setPdfUrl(response.payload.url);
                                  SuccessToast(response.message);
                                  setSelectedFilter(option);
                                  // console.log("🔥 editInvoice thunk fired");
                                } catch (err: any) {
                                  console.log(err);
                                  ErrorHandler(err);
                                } finally {
                                  setSelectedTemplateLoading(false);
                                }
                              }
                            }}
                            classNamePrefix="react-select"
                            className="auth-form-dropdown-control"
                            placeholder="Filter By"
                            isSearchable={false}
                            isClearable={false}
                            loadingMessage={() => "Searching..."}
                            noOptionsMessage={() => "No options found"}
                            menuPortalTarget={document.body}
                            styles={{
                              container: (base: any) => ({
                                ...base,
                                width: 145,
                              }),
                              control: (base: any) => ({
                                ...base,
                                width: "100%",
                                minWidth: 141,
                              }),
                              menuPortal: (base: any) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                            }}
                          />
                        </div>
                      )}
                      <CustomButton
                        newClassName="bg-white border-1 border-primary d-flex align-items-center justify-content-center"
                        onClick={() => {
                          setShowTemplatePreview(true);
                        }}
                        text="Templates"
                        textColor="text-primary"
                      />
                    </div>
                  </div>
                </CardHeader>
                <CardBody className="gap-4 d-flex flex-column">
                  {selectedTemplate === "classic" && (
                    <div className="template-preview-wrapper">
                      <TemplateFirst
                        companyDetails={user?.company}
                        clientDetails={
                          isEdit ? invoiceDetails?.client : quoteDetails?.client
                        }
                        selectedOption={selectedFilter?.value}
                        tableData={addedItems}
                        referenceNumber={
                          invoiceDetails?.quote?.reference_number ??
                          quoteDetails?.reference_number
                        }
                        issueDate={selectedDate?.issueDate}
                        dueDate={selectedDate?.dueDate}
                        selectedTab={customActiveTab}
                        jobDescription={jobDescription}
                        quoteTitle={quoteTitle}
                        isCompanyPhoneHidden={isHidePhoneNumber}
                        isCompanyNameHidden={
                          !user?.company?.is_company_name_show
                        }
                      />
                    </div>
                  )}
                  {selectedTemplate === "modern" && (
                    <div className="template-preview-wrapper">
                      <TemplateSecond
                        companyDetails={user?.company}
                        clientDetails={
                          isEdit ? invoiceDetails?.client : quoteDetails?.client
                        }
                        selectedOption={selectedFilter?.value}
                        tableData={addedItems}
                        referenceNumber={
                          invoiceDetails?.quote?.reference_number ??
                          quoteDetails?.reference_number
                        }
                        issueDate={selectedDate?.issueDate}
                        dueDate={selectedDate?.dueDate}
                        selectedTab={customActiveTab}
                        jobDescription={jobDescription}
                        quoteTitle={quoteTitle}
                        isCompanyPhoneHidden={isHidePhoneNumber}
                        isCompanyNameHidden={
                          !user?.company?.is_company_name_show
                        }
                      />
                    </div>
                  )}
                  {selectedTemplate === "elegant" && (
                    <div className="template-preview-wrapper">
                      <TemplateThird
                        companyDetails={user?.company}
                        clientDetails={
                          isEdit ? invoiceDetails?.client : quoteDetails?.client
                        }
                        selectedOption={selectedFilter?.value}
                        tableData={addedItems}
                        referenceNumber={
                          invoiceDetails?.quote?.reference_number ??
                          quoteDetails?.reference_number
                        }
                        issueDate={selectedDate?.issueDate}
                        dueDate={selectedDate?.dueDate}
                        selectedTab={customActiveTab}
                        jobDescription={jobDescription}
                        quoteTitle={quoteTitle}
                        isCompanyPhoneHidden={isHidePhoneNumber}
                        isCompanyNameHidden={
                          !user?.company?.is_company_name_show
                        }
                      />
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <TemplatePreviewModal
          loading={templateLoading}
          template={selectedTemplate}
          showModal={showTemplatePreview}
          toggle={() => {
            setShowTemplatePreview(false);
          }}
          onContinue={async (template: string) => {
            if (invoiceDetails?.id) {
              try {
                setTemplateLoading(true);
                const response = await editInvoiceApi({
                  invoice_id: invoiceDetails?.id,
                  template: template,
                });
                console.log(response);
                SuccessToast(response.message);
                // console.log("🔥 editInvoice thunk fired");
                setSelectedTemplate(template);
                setShowTemplatePreview(false);
                return response;
              } catch (err: any) {
                console.log(err);
                ErrorHandler(err);
                setTemplateLoading(false);
              } finally {
                setTemplateLoading(false);
              }
            }
            setSelectedTemplate(template);
            setShowTemplatePreview(false);
          }}
        />
        <ShareModal
          isOpen={showShareModal}
          onClose={closeShareModal}
          pdfUrl={invoiceDetails?.url}
          route_url={invoiceDetails?.route_url}
          isInvoice={true}
          invoiceDetails={invoiceDetails}
        />
      </div>
      <OverlayGuide {...summaryTour} />
      <OverlayGuide {...itemsTour} />
    </React.Fragment>
  );
};

export default ManageInvoices;
